export default __webpack_public_path__ + "bab10eb4b7b4605500b622735e825deb.jpg";